import InboxApplication from './InboxApplication';
new InboxApplication().start();